import { Route, Routes } from 'react-router-dom';
import Orders from './orders';
import OrderDetails from './orderDetails';
import SurveyMobile from './surveyMobile';


const ProfileMobile = () => {


    return (

    	<div className="flex-grow-1 d-flex flex-column" style={{paddingBottom: '55px', paddingTop: '0px'}}>
	    	<div className="flex-grow-1 bg-neutral-000 d-flex flex-column">
				<div className="relative d-flex flex-column lg:grid grid-cols-1 lg:grid-cols-7 gap-4 gap-y-0 mt-0  pt-4 pb-6 lg:px-4">
					<div className="lg:col-span-5">
						<div>
							<Routes> 
			                    <Route path='/orders' element={<Orders />} />
			                    <Route path='/orders/:uniqueCode' element={<OrderDetails />} />
			                    <Route path='/' element={<SurveyMobile />} />
			                </Routes>
						</div>
					</div>
				</div>
			</div>
		</div>

    );
}

export default ProfileMobile;